export default __webpack_public_path__ + "static/media/polygonAgroup.3d2dccbf.svg";